import React, { useState } from 'react';

const DiscrepancyFileTreeNode = ({ node, toggleSelect }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} className={`${node?.entry_type === 'file' ? 'ms-2' : ''}`}>
        <div className="mb-3">
          {node?.entry_type === 'folder' && (
            <span onClick={handleExpand}>
              <i className={`pi ${expanded ? 'pi-chevron-down' : 'pi-chevron-right'} ms-2`}></i>
              <i className="icon-folder fa-lg ms-2"></i>
            </span>
          )}
          {node?.entry_type === 'file' && (
            <input type="checkbox" checked={!!node?.is_checked_discrepancy || false} onChange={() => toggleSelect(node.file_id)} />
          )}
          <span>
            {node?.entry_type === 'file' && <i className="fas fa-file-pdf ms-2"></i>}
            <span className="ms-2">{node?.display_name}</span>
          </span>
        </div>
      </div>
      {expanded && node?.entry_type === 'folder' && node?.sub_items && (
        <div style={{ marginLeft: 20 }}>
          {Object.entries(node?.sub_items)?.map(([key, child]) => (
            <DiscrepancyFileTreeNode key={child.file_id || key} node={{ display_name: key, ...child }} toggleSelect={toggleSelect} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DiscrepancyFileTreeNode;
